import React, { useEffect, useRef, useState } from 'react'
import isNull from '../../../utils/NullChecking';
import CustomUseRef from '../CustomUseRef/CustomUseRef';
import { Label } from 'reactstrap';

const AvailableSlotsDropdown = (props) => {
    const { availableStartTimeSlots, IsSlotAvailable, handleOnChange, name, value, inputError, handleOnChangeStartTime } = { ...props }

    const [availableSlots, setAvailableSlots] = useState([]);
    const [SlotSchedule, setSlotSchedule] = useState('Scheduled');
    const [filteredAvailableSlots, setfilteredAvailableSlots] = useState([]);
    const [notScheduledFilteredArray, setNotScheduledFilteredSlots] = useState([]);
    const [filterstatus, setFilterstatus] = useState(false);
    const [chunkedArray, setChunkedArray] = useState([]);
    const [counter, setCounter] = useState(0);

    const handleSlotScheduleChange = (e) => {
        const { name, value, checked } = e.target;
        setSlotSchedule(name);
    }

    const closeDropdown = () => {
        setFilterstatus(false)
    };

    const handleFilterOpen = (e) => {

        setCounter(0);
        setSlotSchedule('Scheduled');
        setTimeout(() => {
            setFilterstatus(!filterstatus);
        }, 0)
        // e.stopPropagation();
    }

    useEffect(() => {

        if (availableStartTimeSlots?.length > 0) {
            let filteredArray = availableStartTimeSlots.filter((slot) => slot?.InScheduled == 1);
            let notScheduledFilteredArray = filteredArray.filter((item) => item.IsScheduled == 0);
            setNotScheduledFilteredSlots(notScheduledFilteredArray);
            if (SlotSchedule === "Scheduled") {
                let filteredArray = availableStartTimeSlots.filter((slot) => slot?.InScheduled == 1)
                setfilteredAvailableSlots(filteredArray);
            }
            else if (SlotSchedule === "All") {
                let filteredArray = [...availableStartTimeSlots]

                setfilteredAvailableSlots(filteredArray)
            }
            setCounter(0);

        }
        // else if (!isNull(responseByID) && availableStartTimeSlots?.length === 0 && IsSlotAvailable) {
        else if (availableStartTimeSlots?.length === 0) {

            setfilteredAvailableSlots([]);

        }

    }, [SlotSchedule, availableStartTimeSlots]);

    useEffect(() => {
        let filteredArray = filteredAvailableSlots?.filter((item) => !isNull(item?.StartTime))
        let chunkedData = [];
        let resultArray = [];
        for (let i = 0; i < filteredArray.length; i += 4) {
            chunkedData.push(filteredArray?.slice(i, i + 4));
        }
        for (let i = 0; i < chunkedData.length; i += 12) {
            resultArray.push(chunkedData?.slice(i, i + 12))
        }

        setChunkedArray(resultArray);
    }, [filteredAvailableSlots])
    ////////////////////////////////////////////////////////////////


    const [divStyle, setDivStyle] = useState();
    const listRef = useRef(null);
    const parentRef = useRef(null);
    const handleParentClick = () => {
        const rect = parentRef.current?.getBoundingClientRect();
        if (!rect) return;

        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        const dropdownElement = listRef.current;

        const actualDropdownHeight = dropdownElement?.offsetHeight || 0;
        const actualDropdownWidth = dropdownElement?.offsetWidth || rect.width;

        let top = rect.bottom;
        let left = rect.left;

        if (
            rect.bottom + actualDropdownHeight > viewportHeight &&
            rect.top >= actualDropdownHeight
        ) {
            top = rect.top - actualDropdownHeight;
        }

        if (left + actualDropdownWidth > viewportWidth) {
            left = viewportWidth - actualDropdownWidth - 10;
        }

        if (left < 0) {
            left = 10;
        }

        setDivStyle({
            top,
            left,
            position: "fixed",
        });
    };
    useEffect(() => {
        if (!filterstatus) return;

        requestAnimationFrame(() => {
            handleParentClick();
        });
    }, [SlotSchedule, chunkedArray, counter]);
    ////////////////////////////////////////////////////////////////
    return (
        <div className='ar-available-slot'>
            {/* New Design  */}
            {
                // availableStartTimeSlots.length != 0 && notScheduledFilteredArray.length != 0 ?
                <div onClick={handleParentClick} ref={parentRef}>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="h:mm am"
                        id="AppointmentStart"
                        name={name}
                        maxlength="55"
                        onChange={handleOnChange}
                        onClick={(e) => handleFilterOpen(e)}
                        value={value}
                        readOnly
                    />
                </div>
                // :
                // <p className="form-control m-0" >No Slot Available</p>
            }

            <CustomUseRef onClose={closeDropdown} IsActivePtPayments={filterstatus} >
                <div className='ar-quick-selection position-fixed' style={divStyle} ref={listRef}>
                    <div className='d-flex align-items-center justify-content-between mb-2'>
                        <p className='heading'>Quick Selections</p>
                        <div className="border-0 claims-TabHeader d-block w-auto">
                            <div className="claims-TabHeader__right pe-0">
                                <button className={`btn ${counter === 0 ? 'disable pe-none' : ''}`} onClick={() => setCounter(counter - 1)}><i className="icon-Icon-ionic-md-arrow-round-back"></i></button>
                                <button className={`btn ${counter >= chunkedArray?.length - 1 ? 'disable pe-none' : ''}`} onClick={() => setCounter(counter + 1)}><i className="icon-arrow-right"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex gap-3">

                        <label className="ar_radio-btn d-flex align-items-center gap-1">
                            <input
                                type="radio"
                                name='All'
                                id="All"
                                onChange={handleSlotScheduleChange}
                                checked={SlotSchedule === "All"}
                            />
                            <p for="Active" className="text fs-11 ar-orange-text" >All</p>
                        </label>
                        <label className="ar_radio-btn d-flex align-items-center gap-1">
                            <input
                                type="radio"
                                name='Scheduled'
                                id="Scheduled"
                                onChange={handleSlotScheduleChange}
                                checked={SlotSchedule === "Scheduled"}
                            />
                            <p for="InActive" className="text fs-11 ar-orange-text" >Scheduled</p>
                        </label>
                    </div>
                    <div className='row row-gap-8 mt-2 m-0'>
                        {chunkedArray?.length > 0 && chunkedArray[counter]?.map((chunk, index) => {

                            return (
                                <div className="col-md-2 ps-0 pe-1-5">
                                    {chunk?.map((time, index) => {
                                        return (
                                            <p className={`text ${index === 0 && 'drk-green-clr font-m'} cursor-pointer ${(time?.IsScheduled == 1 || time?.InScheduled == 0) ? 'pe-none opacity-50' : ''} ${value === time?.StartTime ? 'orange-clr font-sb' : ''}`}
                                                onClick={(e) => { handleOnChangeStartTime(e, name, time?.StartTime); closeDropdown(); }}>
                                                {time?.StartTime}
                                            </p>
                                        )
                                    })}
                                </div>)
                        })}
                    </div>
                </div>
            </CustomUseRef>
            {/* } */}
        </div>

    )
}

export default AvailableSlotsDropdown
